<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <SysGrupoAutocomplete
      v-model="filtros.grupo"
      label="Grupos"
      outlined
      hide-details
    />

    <SysSegmentoAutocomplete
      v-model="filtros.segmentos"
      label="Departamentos"
      outlined
      multiple
      hide-details
      class="mt-4"
    />

    <SysSecaoAutocomplete
      v-model="filtros.secao"
      label="Seção"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      hide-details
      class="mt-4"
    />

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      label="Fornecedores"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      hide-details
      class="mt-4"
    />

    <SysCompradorAutocomplete
      v-model="filtros.compradores"
      label="Compradores"
      outlined
      hide-details
      multiple
      class="mt-4"
      :ids-segmento="filtros.segmentos"
    />

    <form
      :action="URL_RELATORIO"
      method="post"
      target="_blank"
      ref="submit-form-relatorio-sugestao-categorias"
    >
      <input type="text" hidden name="filtros" :value="JSON.stringify(filtros)" />
    </form>
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete";
import SysSecaoAutocomplete from '../../utils/crud/SysSecaoAutocomplete.vue';

export default {
  name: "Exemplo",
  mixins: [Mixin],
  components: {
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    SysCompradorAutocomplete,
    SysSecaoAutocomplete
  },
  data: () => ({
    filtros: {
      grupo: 1,
      filial: -1,
      segmentos: [],
      secao: [],
      fornecedores: [],
      compradores: [],
    }
  }),
  watch: {
    DIALOG_ATIVO(valor) {
      if(!valor) {
        this.filtros.segmentos = [];
        this.filtros.fornecedores = [];
        this.filtros.compradores = [];
      }
    }
  },
  computed: {
    GET_BASE_URL() {
      if (window.__APP_CONFIG__.VUE_APP_MULTI_DATABASE === "true" || window.__APP_CONFIG__.VUE_APP_MULTIPLAS_BASE_URL === "true") {
        return localStorage.baseUrl||window.__APP_CONFIG__.VUE_APP_URL_BASE;
      }

      return window.__APP_CONFIG__.VUE_APP_URL_BASE;
    },
    URL_RELATORIO() {
      return this.GET_BASE_URL + '/api/' + this.relatorio.url;
    }
  },
  methods: {
    gerarRelatorio() {
      this.$refs['submit-form-relatorio-sugestao-categorias'].submit();
      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
